/* eslint-disable max-len */

import React from 'react'

import { Paragraph } from '../../components'

import styles from './styles'

const About = ({ style }) => (
	<div style={{ ...styles.container, ...style }}>
		<Paragraph>
			I am currently the sole proprietor of Robert A Hacker Attorney at Law +
			Sports Media Consulting. I provide production counsel for sports,
			including various esports organizations (event and team related) and
			entertainment properties, represent above-the-line talent, and consult on
			various sports related issues.
		</Paragraph>
		<Paragraph>
			I was the Vice President of Business and Legal Affairs for FOX Sports for
			18 years. In my capacity as the VP of FOX Sports, I negotiated, drafted
			and reviewed agreements for both the network sports business and the
			national cable channels, FS 1 and FS 2. These included rights agreements,
			such as the NFL, MLB and NASCAR; above-the-line production deals, such as
			talent, producer, and director agreements; and all production related
			contacts, ranging from mobile production facilities to graphics packages
			to hospitality agreements. In addition, I provided like legal services for
			foxsports.com and its related companies, as well as working with FOX's
			Labor Relations group--including participating in bargaining sessions--
			and the Labor and Employment group (I was responsible for employment
			classification for much of the FOX Entertainment Group). For three years I
			also headed the FOX Sports Music department. Prior to coming to FOX, I was
			in private practice. I began as an associate with two small firms,
			eventually founding my own firm in 1993. During the course of my private
			practice I transitioned from being a commercial litigator, to a real
			estate litigator, to a transactional real estate attorney, specializing in
			construction and leasing, to production counsel for cable television
			movies and series. I am a graduate of the University of California (1976)
			and San Fernando Valley College of Law (1979), and am admitted to practice
			in California and before all US District Courts in California, as well as
			the Ninth Circuit.
		</Paragraph>
		<Paragraph>
			I have been active in the Sports Lawyers Association (SLA) since 2001,
			have been on the board since 2005 and am the President of the
			organization with my two year term commencing May 2019. I have chaired the
			SLA's annual conference three times (most recently in 2016), serve on the
			conference, venue and student writing committees, and have been a member
			of the SLA executive committee. I have also served on various boards
			including AYSO Region 7, the Santa Monica Rugby Club (2005 and 2006 Men's
			D-1 National Champions, as well as a former player and a coach for both
			the men's and women's teams) and I currently serve on the California Rugby
			Advisory Board, for the Cal Rugby team.
		</Paragraph>
		<Paragraph>
			In addition to having been an SLA conference chair and vice-chair, I have
			been a regular panelist and/or moderator at the SLA annual conference. I
			have also participated as a speaker at the ABA Forum on Sports and
			Entertainment and TRAC events, at sports conferences/symposia at Berkeley
			Law and Harvard Law and have lectured at many other law schools across the
			country.
		</Paragraph>
	</div>
)

export default About



// WEBPACK FOOTER //
// ./src/views/About/index.js